import React, { useState } from "react";
import { Loader2, PenLine, Plus } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export function AddCharterButton({ onAdded, edit }: { onAdded: () => void; edit?: { charter: string; name: string } }) {
  const [open, setOpen] = useState(false);
  const [num, setNum] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const show = () => { setNum(edit?.charter || ""); setName(edit?.name || ""); setOpen(true); };
  const save = async () => {
    setBusy(true);
    try {
      const body = { charter: num.trim(), name: name.trim() };
      const { data } = edit ? await api.put(`/dow/charters/${encodeURIComponent(edit.charter)}/rename`, body) : await api.post("/dow/charters", body);
      toast.success(edit ? `Updated to Charter ${data.charter} ${data.name}` : `Charter ${data.charter} ${data.name} added. Click Edit on it to add its contacts.`);
      setOpen(false); onAdded();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const tid = edit ? `dow-charter-rename-${edit.charter}` : "dow-charter-add";
  return (
    <>
      {edit ? <button className="btn-secondary btn-sm" title="Fix charter number or name" onClick={show} data-testid={`${tid}-open`}><PenLine className="h-4 w-4" /> Rename</button>
        : <button className="btn-primary btn-sm" onClick={show} data-testid={`${tid}-open`}><Plus className="h-4 w-4" /> Add charter</button>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid={`${tid}-dialog`}>
          <DialogHeader><DialogTitle>{edit ? `Rename Charter ${edit.charter}` : "Add a charter"}</DialogTitle></DialogHeader>
          <p className="text-sm text-[#64748B]">{edit ? "Fix a typo in the number or name. Everyone filed under this charter, its contacts and its applicants move with it." : "The new charter shows everywhere straight away: the parish/school lists, outside clearances, coordinator lists and certificates. Anyone already on file under this school name is linked to it."}</p>
          <div className="grid gap-3 sm:grid-cols-[8rem_1fr]">
            <label className="text-sm font-medium">Charter #<input className="field-input mt-1" value={num} onChange={(e) => setNum(e.target.value)} placeholder="e.g. 211" data-testid={`${tid}-number`} /></label>
            <label className="text-sm font-medium">Parish / school name<input className="field-input mt-1" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. St. Mary Academy" data-testid={`${tid}-name`} /></label>
          </div>
          <div className="mt-2 flex justify-end gap-2">
            <button className="btn-secondary btn-sm" onClick={() => setOpen(false)} data-testid={`${tid}-cancel`}>Cancel</button>
            <button className="btn-primary btn-sm" disabled={busy || !num.trim() || name.trim().length < 2} onClick={save} data-testid={`${tid}-save`}>
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} {edit ? "Save changes" : "Add charter"}</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
